<template>
  <div class="page-error">
    <div class="title">{{$t('page.error.title')}}</div>
    <p class="code-message">{{code}}:{{message}}</p>
    <p v-if="code >= 0">
      <Button v-if="code!=404" class="dark-btn" @click="$router.back()"
              style="margin-right: 20px;">
        {{$t('common.btn_back')}}
      </Button>
      <Button class="dark-btn" @click="$router.replace('/')">
        {{$t('page.jump.index')}}
      </Button>
    </p>
    <p class="goto-official">{{$t('page.jump.to_official')}}
      <Button class="dark-btn" @click="$router.face.gotoOfficial()" ghost>
        {{$t('page.jump.official')}}
      </Button>
    </p>
  </div>
</template>

<script>
    export default {
        data () {
            return {
                code: 0,
                message: ''
            }
        },
        methods: {
            onRefresh (to) {
                if (!to) {
                    to = this.$route;
                }
                const err = to.params.error;
                if (err) {
                    this.code = err.code;
                    this.message = err.message;
                } else {
                    this.$router.replace('/');
                }
            }
        },
        beforeRouteUpdate (to, from, next) {
            this.onRefresh(to);
            next();
        },
        created () {
            this.onRefresh();
        }
    }
</script>

<style lang="scss">
  .page-error {
    padding: 16px;
    text-align: center;
    .code-message {
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .goto-official {
      line-height: 30vh;
    }
  }
</style>
